import { render, staticRenderFns } from "./PageManageUltimateLearningOutcome.vue?vue&type=template&id=bb8a81b4&"
import script from "./PageManageUltimateLearningOutcome.vue?vue&type=script&lang=js&"
export * from "./PageManageUltimateLearningOutcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports